import { useEffect, useState } from "react";
import MediaFrom from "../media/MediaFrom";
import {
  CForm,
  CFormLabel,
  CFormInput,
  CButton,
  CFormTextarea
} from '@coreui/react';
import AxiosInstance from "../Axios";

const AddItemGallery = ({ toastifySuccess, data, parent_id, actionShowModal , gallery}) => {
  const [media, setMedia] = useState((data != undefined && data.media != undefined) ? data.media.id : false);
  const [name, setName] = useState((data != undefined) ? data.name : '');
  const [urlPhoto, setUrlPhoto] = useState((data != undefined) ? data.urlPhoto : '');
  const [urlVideo, setUrlVideo] = useState((data != undefined) ? data.urlVideo : '');
  const [content, setContent] = useState((data != undefined) ? data.content : '');
  const [mediaData, setMediaData] = useState(false);
  useEffect(() => {
    if (media != false)
      AxiosInstance.get(`/media_objects/${media}`).then((responce) => {
        if (responce.status == 200) {
          setMediaData(responce.data);
        }
      });
  }, [media]);

  const handleSubmit = event => {
    event.preventDefault();

    const article = {
      name: name,
      content: content,
      gallery: `/api/galleries/${parent_id}`,
      // media: `/api/media_objects/${media}`,
      urlPhoto: urlPhoto,
      urlVideo: urlVideo

    };
    if (media != false)
      article['media'] = `/api/media_objects/${media}`;
    if (data != undefined) {
      const response = AxiosInstance.put('/gallery_items/' + data.id, article).then((response) => {
        if (response.status == 200) {
          toastifySuccess('Галерею оновлено');
          // actionShowModal(setShowModal(!rez), getItems()); перший параметр (закрити модальне вікно), другий - оновити дані)
          actionShowModal(false);
        }
      });
    } else {
      const response = AxiosInstance.post('/gallery_items', article).then((response) => {
        // console.log(response);
        if (response.status == 201) {
          // actionShowModal(setShowModal(!rez), getItems()); перший параметр (закрити модальне вікно), другий - оновити дані)
          actionShowModal(false);
          toastifySuccess("Галерею створено")
        }
      });
    }
  }

  function handleFTP(){
    const formatType = transliterate(gallery.type).toLowerCase().replace(/ /g, '_');
    AxiosInstance.get(`/create-dir-ftp?gallery_id=${parent_id}&type=${formatType}`).then(response => {
      const data = response.data;
      if (data?.url !== undefined) {
        const ftpIp = process.env.REACT_APP_FTP_IP  || false;
        const ftpUser = process.env.REACT_APP_FTP_USER || false;
        if (!ftpIp || !ftpUser) {
          toastifySuccess("FTP не вказані доступи в .env файлі");
          return;
        }
        const ftp = 'winscp-ftp://' + ftpUser + '@' + ftpIp + '/objects' + data.url + '/';
        window.open(ftp, '_blank', 'noopener,noreferrer');
      }
    }).catch(() => {
      toastifySuccess("Error create directory");
    })
  }

  return (<>
    <div className="d-flex gap-5">
      {(mediaData) && <img src={process.env.REACT_APP_SERVER_URL + mediaData.contentUrl} with="200px" />}
      <MediaFrom type="category" setNewMediaId={setMedia} toastifySuccess={toastifySuccess} />
    </div>
    <hr />
    <CForm>
      <div className="mb-3">
        <CFormLabel htmlFor="exampleFormControlInput1">Назва</CFormLabel>
        <CFormInput type="text" id="exampleFormControlInput1" value={name} onChange={(e) => setName(e.target.value)} />
      </div>
      <div className="mb-3">
        <CFormLabel htmlFor="exampleFormControlInput1">Url зображення</CFormLabel>
        <div style={{ display: 'flex', gap: '10px' }}>
          <CButton color="secondary" onClick={handleFTP} style={{ minWidth: '200px' }}>Завантажити на FTP</CButton>
          <CFormInput type="text" id="exampleFormControlInput1" value={urlPhoto} onChange={(e) => setUrlPhoto(e.target.value)} />
        </div>
      </div>
      <div className="mb-3">
        <CFormLabel htmlFor="exampleFormControlInput1">Url відео</CFormLabel>
        <CFormInput type="text" id="exampleFormControlInput1" value={urlVideo} onChange={(e) => setUrlVideo(e.target.value)} />
      </div>
      <div className="mb-3">
        <CFormLabel htmlFor="exampleFormControlInput1">Контент</CFormLabel>
        <CFormTextarea id="exampleFormControlInput1" value={content} onChange={(e) => setContent(e.target.value)} row="5" />
      </div>
      <CButton onClick={handleSubmit} color="success">Зберегти</CButton>

    </CForm>
  </>);
}

export default AddItemGallery;